import {Component, inject, OnInit} from '@angular/core';
import {AccessService} from "../../services/access.service";
import {ActivatedRoute, Router} from "@angular/router";
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {DatePipe, DecimalPipe, NgIf} from "@angular/common";
import moment from "moment";

@Component({
    selector: 'app-supplier-price-list-detail',
    imports: [NgIf, ReactiveFormsModule, DatePipe, FormsModule, DecimalPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-table-list me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Lieferantenpreisliste anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Lieferantenpreisliste bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Lieferantenpreisliste
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="row">
                        <div class="col">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                        </div>
                        @if (viewMode != ViewMode.INSERT) {
                            <div class="col">
                                <label>Erstellt am</label>
                                <p>{{ form.value.created_at | date: 'dd.MM.yyyy' }}</p>
                            </div>
                        }
                        <div class="col">
                            <label>Gültig von</label>
                            <input type="date" class="form-control" formControlName="valid_from" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.valid_from | date: 'dd.MM.yyyy' }}</p>
                        </div>
                        <div class="col">
                            <label>Gültig bis</label>
                            <input type="date" class="form-control" formControlName="valid_to" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.valid_to | date: 'dd.MM.yyyy' }}
                                @if (form.value.valid_to == null) {
                                    <span class="text-muted">Nicht gesetzt</span>
                                }
                            </p>
                        </div>
                    </div>
                </form>

                <label class="form-label mt-3">Zugeordnete Stores</label>
                <div class="row row-cols-3">
                    @for (store of stores; track store.id) {
                        <div class="col">
                            @if (viewMode == ViewMode.VIEW) {
                                @if (store.selected) {
                                    <div class="mb-2">{{ store.name }}</div>
                                }
                            } @else {
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"
                                           [id]="'store_check_' + store.id"
                                           [(ngModel)]="store.selected">
                                    <label class="form-check-label fw-normal" [for]="'store_check_' + store.id">
                                        {{ store.name }}
                                    </label>
                                </div>
                            }
                        </div>
                    }
                </div>

                <label class="form-label mt-3">Produkte</label>
                <div class="table-responsive">
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th style="width: 300px">Lieferant</th>
                            <th>Name</th>
                            <th class="text-end" style="width: 150px">Preis (€)</th>
                            <th class="text-end" style="width: 150px">Standardbestellmenge</th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (product of products; track product; let i = $index) {
                                <tr>
                                    <td>{{product.supplier}}</td>
                                    <td>
                                        {{product.name}}
                                        ({{product.package_amount}} {{product.package_unit}})
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_price | number:'1.2-2' }}
                                            <span class="text-muted" *ngIf="!product.pli_price">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                                   [name]="'product_price_' + i"
                                                   [(ngModel)]="product.pli_price">
                                        }
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_default_quantity }}
                                            <span class="text-muted" *ngIf="!product.pli_default_quantity">0</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm text-end" min="0" step="1"
                                                   [name]="'product_quantity_' + i"
                                                   [(ngModel)]="product.pli_default_quantity">
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>
            </div>
        </div>
    `
})
export class SupplierPriceListDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_pricelist!: string;
    viewMode!: ViewMode;
    pricelist: any;
    products: any[] = [];
    stores: any[] = [];

    ngOnInit(): void {
        this.id_pricelist = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_pricelist == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
            created_at: [null],
            valid_from: [moment().format('YYYY-MM-DD')],
            valid_to: [null]
        });

        this.listStores();

        if (this.id_pricelist !== '0') {
            this.getPriceList();
        } else {
            this.listProducts();
        }
    }

    listStores(): void {
        this.dataService.request('Store/listForSelection').subscribe(response => {
            this.stores = response.stores.map((s: any) => ({
                ...s,
                selected: false
            }));
        });
    }

    getPriceList(): void {
        this.dataService.request('SupplierPriceList/get', {
            id_pricelist: this.id_pricelist
        }).subscribe(response => {
            this.pricelist = response.pricelist;
            this.products = response.products;

            response.assigned_stores.forEach((assigned: any) => {
                const store = this.stores.find(s => s.id == assigned.id_store);
                if (store) {
                    store.selected = true;
                }
            });

            this.patchForm();
        });
    }

    listProducts(): void {
        this.dataService.request('SupplierPriceList/listProducts').subscribe(response => {
            this.products = response.products;
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.pricelist.id,
            name: this.pricelist.name,
            created_at: this.pricelist.created_at,
            valid_from: this.pricelist.valid_from,
            valid_to: this.pricelist.valid_to
        });
    }

    getSelectedStoreIds(): string[] {
        return this.stores.filter(s => s.selected).map(s => s.id);
    }

    save(): void {
        this.dataService.request('SupplierPriceList/save', {
            pricelist: this.form.getRawValue(),
            products: this.products,
            stores: this.getSelectedStoreIds()
        }).subscribe(() => {
            this.router.navigate(['/supplierpricelist']);
            this.toastrService.success('Die Lieferantenpreisliste wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('SupplierPriceList/update', {
            pricelist: this.form.getRawValue(),
            products: this.products,
            stores: this.getSelectedStoreIds()
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getPriceList();
            this.toastrService.success('Die Lieferantenpreisliste wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/supplierpricelist']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Lieferantenpreisliste wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('SupplierPriceList/delete', {
                    id_pricelist: this.id_pricelist
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Die Lieferantenpreisliste wurde gelöscht');
                });
            }
        });
    }
}
